import { useTranslation } from "react-i18next";
import { useFontStyle } from "~/hook/useFontStyle";
import { getEventImageDate } from "~/lib/helperFuncation/formateDate";
import { cn } from "~/lib/utils";

function ArticleNameAndDescription({
  date,
  autherName,
  title,
  description,
}: {
  date: string;
  autherName: string | null;
  title: string;
  description: string;
}) {
  const articleDate = date && getEventImageDate(date);
  const { t } = useTranslation();
  const formattedDate = articleDate ? `${t(`common.${articleDate.month.toLowerCase()}`)} ${articleDate.day},${articleDate.year}` : "Unknown Date";
  const { medium, regular, normalInter } = useFontStyle();

  return (
    <div className="w-full flex flex-col justify-between">
      <div className="w-full flex items-center gap-2 overflow-hidden">
        {date && (
          <span className={cn("body_text_s text-textColor flex-shrink-0 ", normalInter)} title={formattedDate}>
            {formattedDate}
          </span>
        )}
        {autherName && (
          <div className="flex items-center gap-1 min-w-0 overflow-hidden">
            <div className="size-1 rounded-full bg-textColor flex-shrink-0"></div>
            <span
              className={cn("body_text_s text-textColor truncate", normalInter)}
              title={t("blog.by", { name: autherName, defaultValue: `By ${autherName}` })}
            >
              {t("blog.by", { name: autherName, defaultValue: `By ${autherName}` })}
            </span>
          </div>
        )}
      </div>
      <h2 className={cn("body_text_l text-textColor w-full line-clamp-2 ", medium)} title={title}>
        {title}
      </h2>
      <span className={cn("w-full body_text_s text-textColor line-clamp-2", regular)} title={description}>
        {description}
      </span>
    </div>
  );
}

export default ArticleNameAndDescription;
